import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";

const formatErr = (d) => {
  if (!d) return "Une erreur est survenue.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || "").join(" ");
  return String(d);
};

const AdminLogin = () => {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1C1A18] px-6">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-md"
      >
        <p className="text-xs uppercase tracking-[0.2em] text-[#C49A76] mb-4">
          Espace privé
        </p>
        <h1 className="font-serif-el text-5xl text-[#F4F1EB] mb-10">
          Administration
        </h1>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <input
            data-testid="login-email"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-transparent border-b border-[#F4F1EB]/25 text-[#F4F1EB] placeholder:text-[#F4F1EB]/40 py-3 focus:outline-none focus:border-[#C49A76] transition-colors"
            required
          />
          <input
            data-testid="login-password"
            type="password"
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-transparent border-b border-[#F4F1EB]/25 text-[#F4F1EB] placeholder:text-[#F4F1EB]/40 py-3 focus:outline-none focus:border-[#C49A76] transition-colors"
            required
          />
          {error && (
            <p data-testid="login-error" className="text-[#E07856] text-sm">
              {error}
            </p>
          )}
          <button
            data-testid="login-submit"
            disabled={loading}
            className="w-full bg-[#C49A76] text-[#1C1A18] uppercase tracking-[0.15em] text-sm py-4 mt-4 hover:bg-[#F4F1EB] transition-colors duration-300 disabled:opacity-60"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
